import { render, staticRenderFns } from "./SideDialogEditEvent.vue?vue&type=template&id=3248076c&scoped=true&"
import script from "./SideDialogEditEvent.vue?vue&type=script&lang=js&"
export * from "./SideDialogEditEvent.vue?vue&type=script&lang=js&"
import style0 from "./SideDialogEditEvent.vue?vue&type=style&index=0&id=3248076c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3248076c",
  null
  
)

component.options.__file = "SideDialogEditEvent.vue"
export default component.exports